import ModelEntity from "../../model-entity"
import {EntityType} from "../../../gd/const/item"
import {ProjectAccess} from "../../../gd/const/project"

export type ActionScope = {
    projectId           : ID
    projectAccess?      : ProjectAccess
    applyToSubfolders?  : boolean
    taskTypeIds?        : string[]     // task types this automation is applicable to, undefined means all task types
}

export default class ActionEntity extends ModelEntity {

    name                : string
    scope               : ActionScope

    // named targetItemType (not itemType) - ModelEntity.itemType already means this entity's
    // own EntityType (ACTION, used for RID encoding), which is a different concept from the
    // kind of item this automation applies to (e.g. task) that the backend sends as "itemType"
    targetItemType  : string

    constructor(data:any) {
        super(data['id'], EntityType.ACTION)

        this.name               = data['name']
        this.targetItemType     = data['itemType']
        this.scope              = data['scope']
    }

    applyDelta(data:any):boolean {
        if (_.has(data, 'itemType')) {
            this.targetItemType = data['itemType']
            data = _.omit(data, 'itemType')
        }

        return super.applyDelta(data)
    }

    toJSON():JSONObject {
        return {
            id          : this.id,
            name        : this.name,
            itemType    : this.targetItemType,
            scope       : this.scope,
        }
    }
}
